









import { FileInfo, PathController, VFS } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import FileViewerVideo from '@/views/FileViewerVideo.vue'
import FileViewerImage from '@/views/FileViewerImage.vue'
import Loader from '@/components/Loader.vue'

@Component({
  components: {
    FileViewerVideo, FileViewerImage, Loader
  }
})
export default class FileViewer extends Vue {
  @Prop() pathController!: PathController
  @Prop() root!: FileInfo
  @Prop() children!: FileInfo[]
  @Prop() vfs!: Promise<VFS>
  @Prop() pageConfig!: PageConfig

  private mediumType = ''
  private isReady = false

  private url = ''

  @Watch('root', { immediate: true, deep: true })
  rootChanged (root: FileInfo) {
    this.isReady = false
    this.root = root
    this.mediumType = ''
    this.vfs.then(async (vfs: VFS) => {
      if (!this.root.IsDir) {
        const path = this.pathController.resolve(this.root).path
        this.url = await vfs.ResolveFilename(path)
        this.isReady = true
        // TODO: check mime-type
        switch (this.root.ContentType) {
          case 'text/html':
            this.mediumType = 'web'
            break
          case 'application/pdf':
            this.mediumType = 'web'
            this.url = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${this.url}`
            break
          case 'video/mp4':
            this.mediumType = 'video'
            break
          case 'image/png':
          case 'image/jpeg':
            this.mediumType = 'image'
            break
        }
      }
    })
  }
}
